(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sorelay-bundle-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sorelay-bundle-card')) {
    customElements.define('sorelay-bundle-card', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const form = this.querySelector('form');
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = form.querySelector('button[name="add"]');
          const error = form.querySelector('[data-set-error]');
          if (button.disabled) return;
          button.disabled = true;
          error.hidden = true;
          try {
            const response = await fetch(form.action + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: form.elements.id.value, quantity: 1 }] })
            });
            if (!response.ok) throw new Error('Cart request failed');
            window.location.assign(this.dataset.cartUrl);
          } catch {
            error.hidden = false;
            button.disabled = false;
          }
        });
        const select = this.querySelector('select[name="id"]');
        if (!select) return;
        const variants = JSON.parse(this.querySelector('[data-set-variants]').textContent);
        const update = () => {
          const variant = variants[select.value];
          if (!variant) return;
          this.querySelector('[data-set-price]').textContent = variant.price;
          const separate = this.querySelector('[data-set-separate]');
          separate.textContent = variant.separate;
          separate.hidden = !variant.showSeparate;
          this.querySelector('button[name="add"]').disabled = !variant.available;
          variant.images.forEach((image, index) => {
            const img = this.querySelector(`[data-component-image="${index}"] img`);
            if (img && image.url) { img.removeAttribute('srcset'); img.src = image.url; img.alt = image.alt; }
          });
        };
        const choices = [...this.querySelectorAll('[data-set-option]')];
        const chosen = variants[select.value];
        choices.forEach((choice, index) => { choice.value = chosen.options[index]; });
        this.querySelector('[data-set-choices]').hidden = false;
        this.querySelector('[data-set-fallback]').hidden = true;
        const sync = () => {
          const values = choices.map(choice => choice.value);
          const entry = Object.entries(variants).find(([,value]) => value.options.every((option,index) => option === values[index]));
          if (entry) { select.value = entry[0]; update(); }
          else { this.querySelector('button[name="add"]').disabled = true; }
          choices.forEach((choice,index) => {
            [...choice.options].forEach(option => {
              option.disabled = !Object.values(variants).some(value => value.available && value.options[index] === option.value && value.options.every((v,i) => i === index || v === values[i]));
            });
          });
        };
        choices.forEach(choice => choice.addEventListener('change', sync));
        select.addEventListener('change', update);
        sync();
        update();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
